import { Component } from '@angular/core';
import { VERSION } from '../environments/version';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from './core/constants';
import { Store } from '@ngxs/store';
import { environment } from 'environments/environment';
import { EnvironmentTiers } from 'environments/environment.models';

@Component({
    selector: 'one-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    public favicon = document.getElementById('favicon') as HTMLLinkElement;

    // eslint-disable-next-line complexity
    constructor(
        private _translate: TranslateService,
        private _store: Store
    ) {
        // eslint-disable-next-line no-console
        console.log('APP VERSION:::', VERSION, VERSION.tag);

        // Switch the favicon based on the environment
        if ( this.favicon && environment.tier !== EnvironmentTiers.PRODUCTION ) {
            if ( environment.tier === EnvironmentTiers.LOCAL ) {
                this.favicon.href = '/assets/projects/one-app/favicons/favicon_local.ico';
            } else if ( environment.tier === EnvironmentTiers.QA ) {
                this.favicon.href = '/assets/projects/one-app/favicons/favicon_qa.ico';
            }
        }

        this._translate.setDefaultLang(CONSTANTS.defaultLocale);
        this._translate.use(CONSTANTS.defaultLocale);
    }
}
